<template>
  <div class="row">
    <div class="col-12">
      <div class="form-wrap">
        <b-form>
          <div
            id="titre-filter-group"
          >
            <b-form-input
              v-model="formData.nom"
              id="titre-filter-input"
              type="text"
              required
              placeholder="Nom du projet"
            >
            </b-form-input>
          </div>
          <div
            id="client-group"

          >
            <b-form-select
              id="client-input"
              type="text"
              :options="clientsList"
              v-model="formData.client"
            >
              <template slot="first">
                <option value="">Client</option>
              </template>
            </b-form-select>
          </div>
          <div id="type-group">
            <b-form-select
              id="type-input"
              type="text"
              :options="erpOptions"
              v-model="formData.typeErp"
            >
              <template slot="first">
                <option value="">Type</option>
              </template>
            </b-form-select>
          </div>
          <div id="ville-group">
            <b-form-input
              v-model="formData.ville"
              id="ville-input"
              type="text"
              required
              placeholder="Ville"
            >
            </b-form-input>
          </div>
          <div id="type-group">
            <b-form-select
              id="statut-input"
              :options="['En cours', 'Terminé']"
              v-model="formData.statut"

            >
              <template slot="first">
                <option value="">Statut</option>
              </template>
            </b-form-select>
          </div>
          <div
            id="numero-group"
          >
            <b-form-input
              v-model="formData.numeroAffaire"
              id="numero-input"
              type="text"
              placeholder="Numéro d'affaire"
            >
            </b-form-input>
          </div>
          <div class="form-group text-center">
            <button
              class="btn btn-primary w-100"
              @click.prevent="handleFilterProjectsList"
            >
              Filtrer les résultats
            </button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      formData: {
        nom: '',
        client: '',
        typeErp: '',
        ville: '',
        statut: '',
        numeroAffaire: ''
      },
      clientsList: [],
      erpOptions: []
    }
  },
  mounted () {
    this.createOptionsErp()
    this.formatClientsSelect()
  },
  methods: {
    ...mapActions(['listAdminClient', 'getTypeErp']),
    ...mapGetters(['userSocieteId']),
    formatClientsSelect () {
      this.listAdminClient({ data: this.userSocieteId() }).then(resp => {
        this.clientsList = resp.items.map(x => {
          return {
            value: x.id,
            text: x.nom
          }
        })
      })
    },
    createOptionsErp () {
      this.getTypeErp().then((resp) => {
        let option = []
        Object.keys(resp.items).forEach(function (item) {
          option = [...option, ...resp.items[item].typeErp]
        })

        this.erpOptions = option.map(erpItem => {
          return {
            value: erpItem.id,
            text: erpItem.nom
          }
        })
      })
    },
    handleFilterProjectsList () {
      this.$emit('handleFilter', this.formData)
    }
  }
}
</script>

<style lang="scss">
.section-titre {
  h2 {
    color: #2b3085;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    font-family: "Open Sans";
  }
}

</style>



// WEBPACK FOOTER //
// src/components/utils/filterComponent.vue